/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import {
  READ_INVOICE,
  INVOICE_PATH,
  READ_INVOICE_LIST,
  CREATE_INVOICE,
  UPDATE_INVOICE,
} from 'domain/finance/invoice/useInvoiceService';
import InvoiceList from 'domain/finance/invoice/List';
import InvoiceViewPage from 'domain/finance/invoice/Show';
import InvoiceCreatePage from 'domain/finance/invoice/createupdate/Create';
import InvoiceUpdatePage from 'domain/finance/invoice/createupdate/Update';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';

const useInvoiceRoute = () => {
  const routers = createRoute({ listRoute: INVOICE_PATH });

  return { ...routers, copyEntityRoute: `${routers.singleEntityRoute}/copy` };
};

const InvoiceRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    listRoute,
    singleEntityRoute,
    createRoute: createInvoiceRoute,
    copyEntityRoute,
    updateRoute,
  } = useInvoiceRoute();

  return (
    <ProtectedRouter basePath={INVOICE_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_INVOICE_LIST}>
              <InvoiceList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={createInvoiceRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_INVOICE}>
              <InvoiceCreatePage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={copyEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_INVOICE}>
              <InvoiceCreatePage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={updateRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={UPDATE_INVOICE}>
              <InvoiceUpdatePage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_INVOICE}>
              <InvoiceViewPage />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

InvoiceRouter.getRouterPath = () => `${INVOICE_PATH}/*`;

export default InvoiceRouter;
